import { render, staticRenderFns } from "./view5.vue?vue&type=template&id=49c12958&scoped=true"
import script from "./view5.vue?vue&type=script&lang=js"
export * from "./view5.vue?vue&type=script&lang=js"
import style0 from "./view5.vue?vue&type=style&index=0&id=49c12958&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c12958",
  null
  
)

export default component.exports